import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CacheService } from './../Services/cache.service';
import {
  getCacheConfigForRequest,
  getInvalidationTagsForRequest
} from '../core/cache/cache.config';

/**
 * HTTP cache interceptor: caches GETs by URL and invalidates by tags on mutations.
 * Behaviour is driven by core/cache/cache.config.ts (TTL and tags per URL, invalidation rules).
 */
@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(private cacheService: CacheService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const method = req.method.toUpperCase();

    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
      const tags = getInvalidationTagsForRequest(req);
      this.cacheService.invalidateByTags(tags);
      return next.handle(req);
    }

    if (method === 'GET') {
      const config = getCacheConfigForRequest(req);
      if (config.cache === false) {
        return next.handle(req);
      }

      const cachedResponse = this.cacheService.get(req);
      if (cachedResponse) {
        return of(cachedResponse);
      }

      return next.handle(req).pipe(
        tap(event => {
          if (event instanceof HttpResponse && config.cache === true) {
            this.cacheService.put(req, event, {
              ttlMs: config.ttlMs,
              tags: config.tags
            });
          }
        })
      );
    }

    return next.handle(req);
  }
}
